import React, { Component } from "react";
import { withRouter } from 'react-router';
import Wrp from '../../../hoc/Wrp/Wrp';
import { connect } from 'react-redux';
import { callGET, callPOST } from '../../../Utils/ApiUtil';
import $ from 'jquery';
import * as actions from '../../../store/actions';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import HeaderTabs from "../../../Components/UI/HeaderTabs";
import { getUserInfo, checkIsSystemUser } from "../../../Utils/UserFunctions";
import * as ShipConstants from '../../../Global/Constants';
import DragDropFile from "../../../Components/DragDropFile";

class ImportContainerV2 extends Component {

  state = {
    violations: [],
    status: '',
    importFormFields: [
      {
        name: "Base",
        apiName: "base",
        isChecked: true
      },
      {
        name: "Api",
        apiName: "API",
        isChecked: false,
      },
      {
        name: "Automation",
        apiName: 'automation',
        isChecked: false,
      },
      {
        name: "Steps",
        apiName: "step",
        isChecked: false,
      },
      {
        name: "Calculation",
        apiName: "calculation",
        isChecked: false,
      },
      {
        name: "Window",
        apiName: "window",
        isChecked: false,
      }, {
        name: "PDF Template",
        apiName: "PDFTemplate",
        isChecked: false,
      }, {
        name: "Email Template",
        apiName : "EMailTemplate",
        isChecked: false,
      },{
        name:"Excel Template",
        apiName:"excelTemplate",
        isChecked:false
      },{
        name:"Email To Data",
        apiName:"EMailDataConfig",
        isChecked:false
      }

    ],
    user_id: "",
    uploaded_zip_file: "",
    organization_id: "",
    organizationList: [],
    selectedFile: [],
  }

  componentWillMount = () => {
    this.organizationList();
  }

  organizationList = () => {
    callGET("organizations/organization-list/?orderBy=organization_name&direction=ASC&page=0&size=1000000")
      .then(response => {
        const responseData = response.data.data;
        if (response.data.code === ShipConstants.API_STATUS_SUCCESS) {
          const updateState = { ...this.state };
          updateState.organizationList = responseData.organization_list.content;
          this.setState(updateState);
        }
      }, (error) => {
        console.log(error);
      });
  }

  onChangeHandler = (event) => {
    const { name, value, type } = event.target;
    console.log("onChangeHandler",name.value)
    const updateState = { ...this.state };
    if (type !== undefined && type === "checkbox") {
      updateState.importFormFields = updateState.importFormFields.map((item) => {
        if (item.name === name) {
          item.isChecked = event.target.checked;
        }
        return item;
      })
    } else {
      updateState[name] = value;
    }
    this.setState(updateState);
  }
  /*
    importHandler = () => {
      console.log('importHandler');
      console.log(this.state.importFormFields.organization.value);
      const orgId = this.state.importFormFields.organization.value;
      const header = { 'Content-Type': 'application/json' };
      callPOST("import-metadata/xml/all/"+orgId,{},header)
      .then(response => {
        console.log(response);
        const responseData = response.data;
      .catch(err => {
        console.log(err);
      })
    }*/

  handleImagePreview = (e) => {
    let image_as_base64 = URL.createObjectURL(e.target.files[0])
    let image_as_files = e.target.files[0];

    this.setState({
      image_preview: image_as_base64,
      image_file: image_as_files,
    })
  }

  // On file select (from the pop up) 
  onFileChange = event => {
    console.log("fileOnChange",event)
    const updateState = { ...this.state };
    updateState['selectedFile'] = event.target.files[0];
    this.setState(updateState);
  }
  handleFile = (files)=>{
    console.log("Handle File",files[0])
    const updateState = { ...this.state };
    updateState['selectedFile']= files[0]; 
    console.log(updateState);
    this.setState(updateState);
  }

  importHandler = () => {
    const { importFormFields, organization_id, importIncludes,selectedFile } = this.state;
    console.log("selectedFile",selectedFile);
    const formData = new FormData();
    if(selectedFile.name!==undefined){
      formData.append("uploaded_zip_file", selectedFile);
    }else{
      this.props.failMessage("Please upload zip file and import");
      return true;
    }
    formData.append("type", "text/csv");

    importFormFields.map((arr) => {
      formData.append(arr.apiName, arr.isChecked);
    })
    if (organization_id !== "") {
      formData.append("organization_id", organization_id);
    }
    const header = { 'Content-Type': 'multipart/form-data' };
    this.props.Loader(true);
    callPOST("metadata/import-as-xml", formData, header)
      .then(response => {
        this.props.Loader();
        const responseData = response.data;
        if (responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.succMessage(responseData.message);
          // this.downloadZip(responseData.data);
          if (responseData.violations) {
            this.setState({ violations: responseData.violations, status: 'SUCCESS' });
          }
        } else {
          if (responseData.violations) {
            this.setState({ violations: responseData.violations, status: 'FAIL' });
          }
          this.props.failMessage(responseData.message);
        }
      })
      .catch(err => {
        this.props.Loader();
        this.props.failMessage("Error occured");
        console.log(err);
      })
  }

  render() {

    const breadCrumbs = {
      backHistory: [{
        href: "/settings",
        name: "Settings"
      }],
      pageTitle: "Import/Export",
      buttonList: [{
        name: "Import",
        type: "",
        clickHandler: this.importHandler,
        attributes: {
          className: "btn primary_bg",
        },
      },]
    }
    //HEADER TABS
    const headerTabs = [{
      name: "Import",
      attributes: {
        "aria-selected": false,
        className: "nav-link"
      },
      href: "/import-export/import",
    },
    {
      name: "Export",
      attributes: {
        "aria-selected": false,
        className: "nav-link"
      },
      href: "/import-export/export",
    }]

    const { status, violations,importFormFields,selectedFile} = this.state;
    return (
      <Wrp>
        <BreadCrumbs breadCrumbsList={breadCrumbs} />
        <HeaderTabs
          attributes={{
            className: "nav nav-pills navcrm-primary nav-pills-no-bd fixed-2",
          }}
          headerTabsList={headerTabs} />
        <div className="viewport">
          <div className="view   view-xl">

            <div className="outerPort" >
              <div className="table_Box dataTables_wrapper">
                <div className="table_Header">
                  <div className="d-flex align-items-center justify-content-center" style={{gap:'20px'}}>
                  {
                        checkIsSystemUser()?
                    <div className="form-group mb-0 w-100">
                      <label className="">Choose Organisation</label>
                      
                          <div className="input-group">
                            <select className="form-control" name="organization_id" onChange={e => this.onChangeHandler(e)}>
                              <option value=""></option>
                              {
                                this.state.organizationList.map((arr, i) => {
                                  let organizationName = arr.organization_name;
                                  if(organizationName.length>80){
                                    organizationName = organizationName.substring(0,30)+"...";
                                  }
                                  return <option  value={arr.id}>{organizationName}</option>
                                })
                              }
                            </select>
                          </div>
                   
                    </div>
                    :null
                  }
                    <div className="form-group w-100 p-3 mb-0" style={{"border":"2px dashed #dde0e3"}}>
                      <div className="input-group mb-0">
                          
                          <input type="text" value={(selectedFile.name)?selectedFile.name:""} name="filename" className="form-control" placeholder="No file selected" readonly="readonly" />
                          <div className="d-flex position-relative">
                              <button className="btn  btn-border border-default browseCSV">
                                  <input type="file" accept=".zip" id="fileInput" onChange={this.onFileChange} />
                                  <span className="d-sm-none d-md-block d-none"> Choose Zip File </span>
                                  <span className="d-sm-block d-md-none"> Zip File </span>
                              </button>              
                          </div> 
                      </div>
                      <label className="error_1 error m-0"></label>
                    </div>


                  </div>
                  {/* <div className="row">
                      {
                        checkIsSystemUser()?
                        
                          <div className="col-6">
                              <div className="mt-4">
                              <div className="form-group row">
                                <label className="col-lg-3 col-md-3 col-sm-4">Choose Organisation</label>
                                <div className="col-lg-9 col-md-9 col-sm-8">
                                  <div className="form-group">
                                  <div className="input-group mb-3">
                                    <select className="form-control" name="organization_id" onChange={e => this.onChangeHandler(e)}>
                                      <option value=""></option>
                                      {
                                        this.state.organizationList.map((arr, i) => {
                                          let organizationName = arr.organization_name;
                                          if(organizationName.length>80){
                                            organizationName = organizationName.substring(0,30)+"...";
                                          }
                                          return <option  value={arr.id}>{organizationName}</option>
                                        })
                                      }
                                    </select>
                                    </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        :null
                      }
                      <div className="col-6">
                              <div className="form-group p-3" style={{"border":"2px dashed #dde0e3"}}>
                                  <div className="input-group mb-0">
                                      
                                      <input type="text" value={(selectedFile.name)?selectedFile.name:""} name="filename" className="form-control" placeholder="No file selected" readonly="readonly" />
                                      <div className="d-flex position-relative">
                                          <button className="btn  btn-border border-default browseCSV">
                                              <input type="file" accept=".zip" id="fileInput" onChange={this.onFileChange} />
                                              <span className="d-sm-none d-md-block d-none"> Choose Zip File </span>
                                              <span className="d-sm-block d-md-none"> Zip File </span>
                                          </button>              
                                      </div> 
                                  </div>
                                  <label className="error_1 error m-0"></label>
                              </div>
                          </div>
                      
                  </div> */}
                </div>
                <div className="table_Body ">
                  <div className="row justify-content-md-center">
                    <div className="col-md-4">
                      <div className="card">
                        <div className="card-header">
                          <div className="card-title">  Import DataSet Includes </div>
                        </div>
                        <div className="card-body"  style={{height: "calc(100vh - 390px)",overflow:"auto"}}>

                          <div className="form-group ">
                            
                                {
                                  importFormFields ?
                                    importFormFields.map((arr, i) => {
                                      console.log("import arr",arr)
                                      let displayName = (arr.apiName==='base')?                      <label className="col-md-10">Base Data <br/> [user, profile, layout, organization and others information]</label>
                                      :<label className=" col-md-10">{arr.name} Data</label>
                                      return (
                                        <div className="row">
                                        <div className="col-12">
                                            <div className="form-group row border-bottom">
                                                {displayName}
                                                <div className="col-md-2">
                                                  <div className="material-switch p-2">
                                                    <input id={arr.name+"_include"}
                                                      name={arr.name} 
                                                      type="checkbox" 
                                                      checked={arr.isChecked}
                                                      onChange={this.onChangeHandler}
                                                    />
                                                    <label htmlFor={arr.name+"_include"} className="secondary_bg"></label>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                      </div>
                                      );
                                    })
                                    : null
                                }
                               
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <table className="table mb-0 nowrap">
                    <thead className="table_tHeadBg">
                      <tr>
                        <th>
                          Import DataSet Includes
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="">
                        <td>
                          <div className="selectgroup-pills w-100 border-bottom pb-2 display-flex">
                            {
                              importFormFields ?
                                importFormFields.map((arr, i) => {
                                  console.log("import arr",arr)
                                  let displayName = (arr.apiName==='base')?                      <label className="col-lg-3 col-md-3 col-sm-4">Base Data <br/> [user, profile, layout, organization and others information]</label>
                                  :<label className="col-lg-3 col-md-3 col-sm-4">{arr.name} Data</label>
                                  return (
                                    <div className="row">
                                    <div className="col-12">
                                        <div className="form-group row">
                                            {displayName}
                                            <div className="col-lg-9 col-md-9 col-sm-8">
                                              <div className="material-switch p-2">
                                                <input id={arr.name+"_include"}
                                                  name={arr.name} 
                                                  type="checkbox" 
                                                  checked={arr.isChecked}
                                                  onChange={this.onChangeHandler}
                                                />
                                                <label htmlFor={arr.name+"_include"} className="secondary_bg"></label>
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                  </div>
                                  );
                                })
                                : null
                            }
                          </div>
                        </td> 
                      </tr>
                    </tbody>
                  </table> */}
                </div>
              </div>
                    <div className="card-body hide">
                    <div className="mt-5">
                    
                    </div>
                    <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                          <h6 className="">Import DataSet Includes</h6>
                          </div>
                        </div>
                    </div>
                      <div className="row ">
                        <div className="col-12">
                          <div className="form-group">
                            <div className="selectgroup-pills w-100 border-bottom pb-2 display-flex">
                                {
                                  importFormFields ?
                                    importFormFields.map((arr, i) => {
                                      console.log("import arr",arr)
                                      let displayName = (arr.apiName==='base')?                      <label className="col-lg-3 col-md-3 col-sm-4">Base Data <br/> [user, profile, layout, organization and others information]</label>
                                      :<label className="col-lg-3 col-md-3 col-sm-4">{arr.name} Data</label>
                                      return (
                                        <div className="row">
                                        <div className="col-12">
                                            <div className="form-group row">
                                                {displayName}
                                                <div className="col-lg-9 col-md-9 col-sm-8">
                                                  <div className="material-switch p-2">
                                                    <input id={arr.name+"_include"}
                                                      name={arr.name} 
                                                      type="checkbox" 
                                                      checked={arr.isChecked}
                                                      onChange={this.onChangeHandler}
                                                    />
                                                    <label htmlFor={arr.name+"_include"} className="secondary_bg"></label>
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                      </div>
                                      );
                                    })
                                    : null
                                }
                              </div>
                          </div>
                        </div>
                       

                      </div>
                      <div className="row justify-content-center">

                        {/* <div className="col-8">
                          
                            <div className="input-group">
                              <DragDropFile
                                  handleFile={this.handleFile}
                                  displayMessage="Drag and drop a Zip file to import or Click Upload Button"
                                  allowMultiplefiles ={false}
                                  hasBrowseButton={true}
                                  fileName={(selectedFile.name)?selectedFile.name:""}
                              />
                              <div className="input-group-append">
                                <a className="btn primary_bg input-group-text" onClick={this.importHandler}>
                                  Start Import 
                                </a>
                              </div>
                            </div>        
                            
                            
                       
                        </div> */}

                         


                        

                        {/*<div className="col-6"> 
                            <div className="form-group row">
                              <label htmlFor="inlineinput" className="col-lg-3 col-md-3 col-sm-4">Select Import Window</label> 

                              <div className="col-lg-9 col-md-9 col-sm-8">
                                 <div className="form-group">
                                  <div className="input-group mb-3">  
                                    <select className="form-control"></select>
                                    <div className="input-group-append">
                                      <span onClick={this.importHandler} className="input-group-text cursor-pointer" data-toggle="tooltip" data-placement="top" data-title="Import" data-trigger="hover"><i className="fas fa-file-import fa-lg"></i></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                             
                            </div> 
                          </div>*/}
                        {status !== '' && violations && Array.isArray(violations) && violations.length > 0 ?
                          <div className={status === 'SUCCESS' ? "col alert badge-warning fade show" : "col alert badge-danger fade show"}>
                            <strong>{status === 'SUCCESS' ? 'Warning!' : 'Error'}</strong>
                            <ul className="px-2 list-group list-group-bordered list" style={{ "list-style-type": "disc" }}>
                              {
                                violations.map((item, ind) => {
                                  return (
                                    <li key={ind}>
                                      {item.field_name} : {item.message}
                                    </li>
                                  )
                                })
                              }
                            </ul>
                          </div>
                          : null}
                      </div>
                    </div>
                    </div>
                </div>
              </div>


 
      </Wrp>

    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    Loader: () => dispatch(actions.loader()),
    succMessage: (msg) => dispatch(actions.succMessage(msg)),
    failMessage: (msg) => dispatch(actions.failMessage(msg))
  };
}
export default
  connect(
    null,
    mapDispatchToProps
  )(withRouter(ImportContainerV2));